import { render, staticRenderFns } from "./CameraPicture.vue?vue&type=template&id=73d83466&scoped=true"
import script from "./CameraPicture.vue?vue&type=script&lang=js"
export * from "./CameraPicture.vue?vue&type=script&lang=js"
import style0 from "./CameraPicture.vue?vue&type=style&index=0&id=73d83466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d83466",
  null
  
)

export default component.exports